import { lazy } from 'react';

export const PaymentmethodPage = lazy(() => import('./page-list'));
